import { render, staticRenderFns } from "./CommentBox.vue?vue&type=template&id=44ee8ae2&scoped=true&"
import script from "./CommentBox.vue?vue&type=script&lang=js&"
export * from "./CommentBox.vue?vue&type=script&lang=js&"
import style0 from "./CommentBox.vue?vue&type=style&index=0&id=44ee8ae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ee8ae2",
  null
  
)

export default component.exports